import { t } from "i18next";
import { MDBBtn, MDBDateTimepicker, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle } from "mdb-react-ui-kit";
import { useCallback, useImperativeHandle, useRef, useState, forwardRef, useEffect } from "react";

const AddHolidays = forwardRef((props, ref) => {

    const [addHolidayName, setAddHolidayName] = useState(null);
    const [addHolidayFrom, setAddHolidayFrom] = useState(null);
    const [addHolidayFromTime, setAddHolidayFromTime] = useState(null);
    const [addHolidayTo, setAddHolidayTo] = useState(null);
    const [addHolidayToTime, setAddHolidayToTime] = useState(null);


    const [error, setError] = useState(null);
    const [toTimerror, setToTimerror] = useState(null);
    const [fromTimerror, setFromTimerror] = useState(null);
    const [overlaperor, setoverlaperor] = useState(null);
    const hNameRef = useRef();

    const [addHoliday, setAddHoliday] = useState(false);


    const toggleAddHoliday = () => {
        console.log("reset field ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::")
        console.log("reset field ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::");

        // Reset all fields related to the holiday form
        setAddHolidayName(""); // Clear name input
        setAddHolidayFrom(""); // Clear 'from' date
        setAddHolidayFromTime(""); // Clear 'from' time
        setAddHolidayTo(""); // Clear 'to' date
        setAddHolidayToTime(""); // Clear 'to' time

    };


    const holidayChange = useCallback((e) => {
        const value = e.target.value;
        setAddHolidayName(value);
        if (!value.trim()) {
            setError({ name: { message: "Please enter Name" } });
            hNameRef.current?.focus();
        } else {
            setError(prev => prev?.name ? { ...prev, name: {} } : prev);
        }
    }, []);


    useEffect(() => {
        if (props.onValidationChange) {
            const hasError = !!(
                (error && error.name && error.name.message) ||
                (fromTimerror && fromTimerror.addHolidayFrom && fromTimerror.addHolidayFrom.message) ||
                (toTimerror && toTimerror.addHolidayTo && toTimerror.addHolidayTo.message) ||
                (overlaperor && overlaperor.Holidayerror && overlaperor.Holidayerror.message)
            );
            props.onValidationChange(hasError);
        }
    }, [error, fromTimerror, toTimerror, overlaperor, props.onValidationChange]);

    useImperativeHandle(ref, () => ({
        createHoliday: () => {
            createHoliday();
        }
    }));

    const totimeChange = useCallback((value) => {
        if (!value.trim()) {
            setToTimerror({ addHolidayTo: { message: "Please enter To date" } });
        } else {
            const [date, time] = value.split(",").map(item => item.trim());
            setAddHolidayTo(date);
            setAddHolidayToTime(time);
            setToTimerror(null);
            setoverlaperor(null);
        }
    }, []);

    const formtimeChange = useCallback((value) => {
        if (!value.trim()) {
            setFromTimerror({ addHolidayFrom: { message: "Please enter From date" } });
        } else {
            const [date, time] = value.split(",").map(item => item?.trim());
            setAddHolidayFrom(date);
            setAddHolidayFromTime(time);
            setFromTimerror(null);
            setoverlaperor(null);
        }
    }, []);

    function convertToMinutes(time) {
        const [timePart, modifier] = time?.split(" ");
        const [hours, minutes] = timePart?.split(":").map(Number);
        let newHours = hours;

        if (modifier === "AM" && newHours === 12) {
          newHours = 0;
        } else if (modifier === "PM" && newHours !== 12) {
          newHours = newHours + 12;
        }

        return newHours * 60 + minutes;
      }


    const createHoliday = (e) => {
        console.log("props?.holidays:::" ,props?.holidays)
        let datecheck = addHolidayFrom <= addHolidayTo ? true : false;
        console.log("addHolidayFromtime", addHolidayFromTime)
        console.log("addHolidayTotime", addHolidayToTime)

        let fromTime = addHolidayFromTime && convertToMinutes(addHolidayFromTime);
        let toTime = addHolidayToTime &&  convertToMinutes(addHolidayToTime);

        let timeCheck = (addHolidayFrom == addHolidayTo && fromTime > toTime) ? false : true;
        console.log("datecheck", datecheck)
        console.log("timeCheck", timeCheck)
        console.log("addHolidayFrom", addHolidayFrom)
        console.log("addHolidayTo", addHolidayTo)
        console.log("addHolidayFromTime", fromTime)
        console.log("addHolidayToTime", toTime)
        props?.holidays?.forEach((holiday) => {
            if (holiday.name === addHolidayName) {
                setError({ name: { message: "Holiday already exists" } });

            } console.log("holidayfrom", holiday.from)
            console.log("holidayto", holiday.to)

        });

        let newFromDate = new Date(addHolidayFrom);
        let newToDate = new Date(addHolidayTo);
        console.log("newFromDate", newFromDate)
        console.log("newToDate", newToDate)
        console.log("newFromDate ::::::::::::", newFromDate)
        console.log("newToDate :::::::::::::::", newToDate)
        function formatTime(time) {
            return time === "0" || time === 0 ? "00:00:00" : time;
        }
        let isSameDateTime =
            new Date(`${addHolidayFrom} ${formatTime(addHolidayFromTime)}`).getTime() ===
            new Date(`${addHolidayTo} ${formatTime(addHolidayToTime)}`).getTime();

        console.log("Same date and time:", isSameDateTime);

        let isConflict = false;
        console.log("Holidays ::::" ,  props?.holidays)
        props?.holidays?.forEach((holiday) => {
            const existingFrom = new Date(holiday.from);
            const existingTo = new Date(holiday.to);
            console.log("existingFrom", existingFrom)
            console.log("existingTo", existingTo)

            //  Name already exists
            if (holiday.name === addHolidayName) {
                setError({ name: { message: "Holiday already exists" } });
                isConflict = true;
                return;
            }

            //  Check if date ranges overlap
            const isDateOverlap =
                (newFromDate >= existingFrom && newFromDate < existingTo) ||
                (newToDate > existingFrom && newToDate <= existingTo) ||
                (newFromDate <= existingFrom && newToDate >= existingTo);

            //  If date is same, check time overlap
            const isSameStartDay = newFromDate.toDateString() === existingFrom.toDateString();
            const isSameEndDay = newToDate.toDateString() === existingTo.toDateString();
            const isTimeOverlap =
                (isSameStartDay && fromTime < 1440) || // Holiday starts same day
                (isSameEndDay && toTime > 0);          // Holiday ends same day

            if (isDateOverlap && isTimeOverlap) {
                console.log(" Conflict Detected between:", addHolidayFrom, "and", holiday.from);
                setError({ from: { message: "Holiday date/time overlaps with an existing entry" } });
                isConflict = true;
                return
            }
        });

        if (!addHolidayName || addHolidayName.trim() == "") {
            setError({ name: { message: "Please enter Name" } });
            if (hNameRef) {
                hNameRef.current.focus();
            }
            return;
        } else if (/[^a-zA-Z0-9 ]/.test(addHolidayName.trim())) {
            setError({ name: { message: "Special characters are not allowed!" } });
            return;
        } else if (!addHolidayFrom || addHolidayFrom.trim() == "") {
            setFromTimerror({ addHolidayFrom: { message: "Please enter From date" } });
            return;
        } else if (!addHolidayTo || addHolidayTo.trim() == "") {
            setToTimerror({ addHolidayTo: { message: "Please enter To date" } });
            return;
        }
        else if (isSameDateTime){
            setoverlaperor({ Holidayerror: { message: `The selected holiday's "From" and "To" times are the same. Please choose a different "From" and "To" time range.` } });
            return;
        } else if (!datecheck || !timeCheck) {
            setoverlaperor({ Holidayerror: { message: ` The From date and time cannot be later than the To date and time. Please enter valid values.` } });
            return;
        }else if (isConflict) {
            setoverlaperor({ Holidayerror: { message: `The selected holiday overlaps with an existing entry. Please select a different "From" and "To" time range.`} });
            return;
        }

        else {
            setError(null);
            setToTimerror(null);
            setFromTimerror(null);
            toggleAddHoliday();
        }

        let allrow = {
            id: new Date().getTime(),
            name: addHolidayName.trim(),
            from: addHolidayFrom + " " + addHolidayFromTime,
            to: addHolidayTo + " " + addHolidayToTime,
            position:
                "From " +
                addHolidayFrom +
                " " +
                addHolidayFromTime +
                " to " +
                addHolidayTo +
                " " +
                addHolidayToTime,
        };
        console.log(`JOSon.string${JSON.stringify(allrow)}`);
        props.onSuccess(allrow);
    };

    return (

        <>

            <div>

                <div>
                    <div className="tel-numbers">
                        <strong>{t("name")}</strong>
                    </div>
                    <div className="form pt-1 w-100">
                        <input
                            type="text"
                            ref={hNameRef}
                            className="form-control w-100 form-outline"
                            onChange={(e) => holidayChange(e)}
                            value={addHolidayName}
                            maxLength={15}
                        />
                        {error && error.name && (
                            <p className="text-danger">{error.name.message}</p>
                        )}
                    </div>

                    <div className="d-flex justify-content-between">
                        <div className="tel-numbers mt-2 w-50">
                            <strong>{t("from")}</strong>
                            <div className="form pt-1 w-100">
                            <MDBDateTimepicker
                                dateFormat="mm/dd/yyyy"
                                timeformat="hh:mm A"
                                defaultDate={addHolidayFrom}
                                defaultTime={addHolidayFromTime}
                                inputToggle
                                onChange={formtimeChange}
                                disableOnClickOutside={true}
                            />
                            {fromTimerror?.addHolidayFrom?.message && (
                                <p className="text-danger">
                                    {fromTimerror.addHolidayFrom.message}
                                </p>
                            )}
                            </div>
                        </div>

                        <div className="tel-numbers mt-2 w-50">
                            <strong className="ms-2">{t("to")}</strong>
                            <div className="form pt-1 w-100 ps-2">
                            <MDBDateTimepicker
                                dateFormat="mm/dd/yyyy"
                                timeformat="hh:mm A"
                                defaultDate={addHolidayTo}
                                defaultTime={addHolidayToTime}
                                inputToggle
                                onChange={totimeChange}
                                disableOnClickOutside={true}
                            />
                            {toTimerror?.addHolidayTo?.message && (
                                <p className="text-danger">
                                    {toTimerror.addHolidayTo.message}
                                </p>
                            )}
                            </div>
                        </div>
                    </div>
                    <div>
                    {overlaperor?.Holidayerror?.message && (
                                <p className="text-danger">
                                    {overlaperor.Holidayerror.message}
                                </p>
                            )}
                    </div>
                </div>
            </div>



        </>
    )
});

export default AddHolidays;
